import React from 'react';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
interface ITopicPsaProps {
  settings: any;
}

const TopicPsa: React.FunctionComponent<ITopicPsaProps> = ({ settings }) => (
  <TopicContainer className="psa">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem id="2" className="topic-item psa_1">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem id="3" className="topic-item psa_2">
      <Section2 settings={settings} />
    </TopicItem>
    <TopicItem id="4" className="topic-item psa_3">
      <Section3 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default TopicPsa;
